import React, { useState } from 'react';
export function Agenda() {
  const [activeDay, setActiveDay] = useState<1 | 2>(1);
  const day1 = [{
    time: '8:00 AM - 9:00 AM',
    title: 'Breakfast & Networking',
    description: 'Kick off the event with coffee, tacos, and introductions',
    type: 'morning'
  }, {
    time: '9:00 AM - 10:00 AM',
    title: "Who's in the Room",
    description: 'Interactive session to meet fellow attendees and discover shared challenges',
    type: 'morning'
  }, {
    time: '10:00 AM - 11:30 AM',
    title: 'AI for Commerce CFOs',
    description: 'Best use cases for AI in finance — featuring Claude for Excel and practical tools',
    type: 'morning'
  }, {
    time: '11:30 AM - 1:00 PM',
    title: 'Tech Stack Roundtables (Part 1)',
    description: "2 rotating tables × 10 people × 45 min each. Share what's working in your stack.",
    type: 'morning'
  }, {
    time: '1:00 PM - 2:00 PM',
    title: 'Lunch Break',
    description: 'Catered lunch and open networking',
    type: 'break'
  }, {
    time: '2:00 PM - 3:30 PM',
    title: 'Tech Stack Roundtables (Part 2)',
    description: '2 more rotating tables to round out the full circuit.',
    type: 'afternoon'
  }, {
    time: '3:30 PM - 5:00 PM',
    title: 'Financial Reporting Tools & Approach',
    description: 'Reporting frameworks, dashboards, and the KPIs top-performing CFOs track',
    type: 'afternoon'
  }];
  const day2 = [{
    time: '8:00 AM - 9:00 AM',
    title: 'Breakfast & Coffee',
    description: 'Fuel up for day two with breakfast and conversation',
    type: 'morning'
  }, {
    time: '9:00 AM - 10:30 AM',
    title: 'M&A Strategy with Northbound',
    description: 'Navigating acquisitions, valuations, and deal structures in commerce',
    type: 'morning'
  }, {
    time: '10:45 AM - 12:15 PM',
    title: 'Retail Expansion',
    description: 'Financial planning for scaling your physical and digital retail footprint',
    type: 'morning'
  }, {
    time: '12:15 PM - 1:15 PM',
    title: 'Lunch Break',
    description: 'Catered lunch and open networking',
    type: 'break'
  }, {
    time: '1:15 PM - 2:45 PM',
    title: 'Marketing & Finance Alignment',
    description: 'Bridging the gap between marketing spend and financial outcomes',
    type: 'afternoon'
  }, {
    time: '2:45 PM - 3:30 PM',
    title: 'Wrap-Up & Key Takeaways',
    description: 'Closing remarks, action items, and next steps for the community',
    type: 'afternoon'
  }, {
    time: '6:00 PM - 9:00 PM',
    title: 'Private Dinner at Franklin BBQ',
    description: 'Exclusive takeover of the #1 BBQ joint in America',
    type: 'evening'
  }];
  const schedule = activeDay === 1 ? day1 : day2;
  return <section id="agenda" className="py-24 bg-[#FFF8DC]" data-id="element-32">
      <div className="container mx-auto px-4 md:px-6" data-id="element-33">
        <div className="text-center mb-16" data-id="element-34">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2F1B10] font-serif mb-4" style={{
          fontFamily: 'Rockwell, "Courier New", serif'
        }} data-id="element-35">
            Event Agenda
          </h2>
          <div className="w-24 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-36"></div>
          <p className="mt-6 text-lg text-[#556B2F] max-w-2xl mx-auto font-medium" data-id="element-37">
            Two days of insights, connections, and Texas BBQ.
          </p>
        </div>

        {/* Day Tabs */}
        <div className="flex justify-center gap-4 mb-12" data-id="element-38">
          <button onClick={() => setActiveDay(1)} className={`px-8 py-4 rounded-lg font-bold text-lg transition-all ${activeDay === 1 ? 'bg-[#2F1B10] text-[#F4A460] shadow-lg' : 'bg-white text-[#2F1B10] border-2 border-[#D2691E] border-opacity-30 hover:border-opacity-100'}`} data-id="element-39">
            <span className="block text-sm uppercase tracking-widest mb-1 opacity-70" data-id="element-40">
              August 27
            </span>
            Day 1 — Workshops & Tools
          </button>
          <button onClick={() => setActiveDay(2)} className={`px-8 py-4 rounded-lg font-bold text-lg transition-all ${activeDay === 2 ? 'bg-[#2F1B10] text-[#F4A460] shadow-lg' : 'bg-white text-[#2F1B10] border-2 border-[#D2691E] border-opacity-30 hover:border-opacity-100'}`} data-id="element-41">
            <span className="block text-sm uppercase tracking-widest mb-1 opacity-70" data-id="element-42">
              August 28
            </span>
            Day 2 — Strategy & BBQ
          </button>
        </div>

        <div className="max-w-4xl mx-auto relative" data-id="element-43">
          {/* Vertical line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-[#D2691E] opacity-30 hidden md:block" data-id="element-44"></div>

          <div className="space-y-12" data-id="element-45">
            {schedule.map((item, index) => <div key={`${activeDay}-${index}`} className={`flex flex-col md:flex-row gap-8 items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-46">
                <div className="w-full md:w-1/2" data-id="element-47">
                  <div className={`bg-white p-6 rounded-xl shadow-md border-l-4 ${item.type === 'evening' ? 'border-[#8B4513] bg-[#2F1B10] text-white' : 'border-[#D2691E] text-[#2F1B10]'}`} data-id="element-48">
                    <span className={`font-bold text-sm tracking-wider uppercase mb-2 block ${item.type === 'evening' ? 'text-[#F4A460]' : 'text-[#D2691E]'}`} data-id="element-49">
                      {item.time}
                    </span>
                    <h3 className={`text-xl font-bold mb-2 font-serif ${item.type === 'evening' ? 'text-white' : 'text-[#2F1B10]'}`} data-id="element-50">
                      {item.title}
                    </h3>
                    <p className={`${item.type === 'evening' ? 'text-[#F4A460]' : 'text-[#556B2F]'}`} data-id="element-51">
                      {item.description}
                    </p>
                  </div>
                </div>

                {/* Timeline dot */}
                <div className="hidden md:flex absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-[#D2691E] rounded-full border-4 border-[#FFF8DC]" data-id="element-52"></div>

                <div className="w-full md:w-1/2" data-id="element-53"></div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}